"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("../Customer/Document"), exports);
const classTransformer_1 = require("../classTransformer");
const Document_1 = __importDefault(require("../Customer/Document"));
const class_validator_1 = require("class-validator");
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const Customer_1 = __importDefault(require("./Customer"));
const File_1 = __importDefault(require("./File"));
const DocumentHistory_1 = __importDefault(require("./DocumentHistory"));
const DocumentType_1 = __importDefault(require("./DocumentType"));
const DocumentAnchor_1 = __importDefault(require("./DocumentAnchor"));
class Document extends Document_1.default {
}
exports.default = Document;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createFile"], message: "UID is required" }),
    __metadata("design:type", String)
], Document.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DocumentType_1.default),
    __metadata("design:type", DocumentType_1.default)
], Document.prototype, "document_type", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocument"] }),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createDocument"], message: "Folder is required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["createDocument", "updateDocument"] }),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", OfficeFolder_1.default)
], Document.prototype, "folder", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["updateDocument", "createDocument"] }),
    (0, class_validator_1.ValidateNested)({ groups: ["createDocument", "updateDocument"] }),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Customer_1.default)
], Document.prototype, "depositor", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocument", "updateDocument"] }),
    __metadata("design:type", Object)
], Document.prototype, "depositor_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocument", "updateDocument"] }),
    __metadata("design:type", Object)
], Document.prototype, "folder_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocument", "updateDocument"] }),
    __metadata("design:type", Object)
], Document.prototype, "third_party_depositor_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocument", "updateDocument"] }),
    __metadata("design:type", Object)
], Document.prototype, "third_party_depositor", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocument", "updateDocument"] }),
    __metadata("design:type", Object)
], Document.prototype, "shared_to_office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocument", "updateDocument"] }),
    __metadata("design:type", Object)
], Document.prototype, "emitter", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => File_1.default),
    __metadata("design:type", Array)
], Document.prototype, "files", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DocumentHistory_1.default),
    __metadata("design:type", Array)
], Document.prototype, "document_history", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DocumentAnchor_1.default),
    __metadata("design:type", DocumentAnchor_1.default)
], Document.prototype, "document_anchor", void 0);
